import React from 'react';
import { SearchResultsLayout } from '../Common/SearchResultsLayout/SearchResultsLayout';

const SearchResultsDefault = () => {
  return <SearchResultsLayout />;
};

export default SearchResultsDefault;
